module.exports = __webpack_public_path__ + "img/3.a6bd947b.png";